// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".panel-button{display:inline-flex;align-items:center;justify-content:center;border:none;outline:none;border-radius:50%;background:rgba(0,0,0,0);cursor:pointer;transition:all .2s ease-in-out;width:32px;height:32px;padding:0}.panel-button:focus{border:2px solid #0b99c2}.panel-button:hover{background:#e7ebec}.panel-button.active{background:#e7ebec;color:#6b7280}.panel-button.active:hover{background:#d1d5db}", ""]);
// Exports
module.exports = exports;
